import React from 'react';
import styled from 'styled-components';
import { observer } from 'mobx-react';

import { Label } from 'legacyComponents/styled/lib';
import { Icon } from 'components';

export const LabelItem = observer(({ deleteHandler, fieldStore, item }) => {
  const itemText = item[fieldStore.conf.labelKey];
  const deleteButton = (
    <IconStyled
      onClick={() => deleteHandler(item)}
      name='close'
      title='Remove label'
    />
  );
  return (
    <Label
      cursor='pointer'
      backgroundColor={`#${item.color}`}
      onMouseDown={e => {
        if (fieldStore.isFocussed) {
          e.stopPropagation();
          e.preventDefault();
        }
      }}
    >
      {itemText} {deleteButton}
    </Label>
  );
});

const IconStyled = styled(Icon)`
  width: 8px;
  height: 8px;
  margin-left: 10px;
  cursor: pointer;
  &:hover {
    transform: scale(1.3);
  }
`;
